// extracted by mini-css-extract-plugin
export var BlackText = "RecaptchaAttribution-module--BlackText--QFr32";
export var HiddenLg = "RecaptchaAttribution-module--HiddenLg--z8x76";
export var HiddenMd = "RecaptchaAttribution-module--HiddenMd--eaizb";
export var HiddenXl = "RecaptchaAttribution-module--HiddenXl--BykIZ";
export var HiddenXs = "RecaptchaAttribution-module--HiddenXs--atJy4";
export var TextAlignRightXs = "RecaptchaAttribution-module--TextAlignRightXs--5tA+E";
export var WhiteText = "RecaptchaAttribution-module--WhiteText--93sCJ";
export var black = "#181818";
export var blackHSL = "0 0% 9%";
export var desktopWidth = "960px";
export var lgBreakpoint = "60rem";
export var mdBreakpoint = "40rem";
export var recaptchaAttribution = "RecaptchaAttribution-module--recaptchaAttribution--s4msB";
export var srOnly = "RecaptchaAttribution-module--sr-only--pfZk7";
export var visuallyHidden = "RecaptchaAttribution-module--visually-hidden--yGv8l";
export var white = "#fcfcfc";
export var whiteHSL = "0 0% 99%";